export const sizeInMb = function(size) {
  if (size > 1048576) {
    return `${Math.floor(size / 1048576)} mb`
  }
  return `${Math.floor(size / 1024)} kb`
}
